import {PlayerStatType} from "../../PlayerStats/definition";
import {TeamStatType} from "../../TeamStats/definition";
import {EventFilterValue} from "../../../types";

export const createStatTypeFilterValues = (statType: TeamStatType | PlayerStatType): EventFilterValue[] => {
	const filterValues: EventFilterValue[] = [];

	switch (statType) {
		case PlayerStatType.AerialClearance:
			filterValues.push({key: "event.goalkeeper.punch", value: ["punch"]});
			filterValues.push({key: "event.goalkeeper.catch_interception", value: ["catch_interception"]});
			break;
		case PlayerStatType.AerialClearanceSuccess:
			filterValues.push({key: "event.goalkeeper.punch", value: ["punch"]});
			filterValues.push({key: "event.goalkeeper.catch_interception", value: ["catch_interception"]});
			filterValues.push({key: "event.goalkeeper.catch_interception.success", value: ["true"]});
			break;
		case PlayerStatType.AerialDuel:
		case TeamStatType.AerialDuel:
			filterValues.push({key: "event.distribution.aerial_duel", value: ["aerial_duel"]});
			break;
		case PlayerStatType.AerialDuelSuccess:
			filterValues.push({key: "event.distribution.aerial_duel.success", value: ["true"]});
			break;
		case PlayerStatType.Assist:
			filterValues.push({key: "event.distribution.pass.assist", value: ["true"]});
			filterValues.push({key: "event.distribution.aerial_duel.assist", value: ["true"]});
			break;
		case PlayerStatType.Block:
		case TeamStatType.Block:
			filterValues.push({key: "event.defensive.block", value: ["block"]});
			break;
		case PlayerStatType.BlockAndParry:
			filterValues.push({key: "event.goalkeeper.save", value: ["save"]});
			filterValues.push({key: "event.goalkeeper.save.save_type", value: ["parry", "block"]});
			break;
		case PlayerStatType.CardYellow:
			filterValues.push({key: "event.defensive.card.card_type", value: ["yellow"]});
			break;
		case PlayerStatType.CardRed:
			filterValues.push({key: "event.defensive.card.card_type", value: ["red"]});
			break;
		case PlayerStatType.Catch:
			filterValues.push({key: "event.goalkeeper.save", value: ["save"]});
			filterValues.push({key: "event.goalkeeper.save.save_type", value: ["catch"]});
			break;
		case TeamStatType.Clearance:
			filterValues.push({key: "event.defensive.clearance", value: ["clearance"]});
			break;
		case PlayerStatType.Corner:
		case TeamStatType.Corner:
			filterValues.push({key: "event.offensive.shot.restart", value: ["corner-kick"]});
			filterValues.push({key: "event.distribution.pass.restart", value: ["corner-kick"]});
			break;
		case PlayerStatType.Cross:
		case TeamStatType.Cross:
			filterValues.push({key: "event.distribution.pass.cross", value: ["true"]});
			break;
		case PlayerStatType.CrossSuccess:
		case TeamStatType.CrossSuccess:
			filterValues.push({key: "event.distribution.pass.cross", value: ["true"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case TeamStatType.Foul:
		case PlayerStatType.Foul:
		case PlayerStatType.FoulCommited:
			filterValues.push({key: "event.defensive.foul", value: ["foul"]});
			break;
		case PlayerStatType.FoulWon:
		case TeamStatType.FoulWon:
			filterValues.push({key: "event.offensive.foul_won", value: ["foul_won"]});
			break;
		case PlayerStatType.FreeKick:
		case TeamStatType.FreeKick:
			filterValues.push({key: "event.set_pieces.free_kick", value: ["free_kick"]});
			break;
		case TeamStatType.Goal:
		case PlayerStatType.Goal:
			filterValues.push({key: "event.offensive.goal", value: ["goal"]});
			break;
		case PlayerStatType.GoalConceded:
			filterValues.push({key: "event.goalkeeper.goal_conceded", value: ["goal_conceded"]});
			break;
		case PlayerStatType.GoalKick:
			filterValues.push({key: "event.set_pieces.goal_kick", value: ["goal_kick"]});
			break;
		case PlayerStatType.GoalOwn:
			filterValues.push({key: "event.defensive.own_goal", value: ["own_goal"]});
			break;
		case PlayerStatType.GroundDuel:
		case PlayerStatType.GroundDuelSuccess:
			filterValues.push({key: "event.defensive.take_on_against", value: ["take_on_against"]});
			filterValues.push({key: "event.defensive.tackle", value: ["tackle"]});
			break;
		case PlayerStatType.Interception:
		case TeamStatType.Interception:
			filterValues.push({key: "event.defensive.interception", value: ["interception"]});
			break;
		case PlayerStatType.KeyPass:
		case TeamStatType.KeyPass:
			filterValues.push({key: "event.distribution.pass.key_pass", value: ["true"]});
			break;
		case TeamStatType.Mistake:
		case PlayerStatType.TechnicalError:
			filterValues.push({key: "event.offensive.technical_error", value: ["technical_error"]});
			break;
		case PlayerStatType.Offside:
		case TeamStatType.Offside:
			filterValues.push({key: "event.offensive.offside", value: ["offside"]});
			break;
		case PlayerStatType.Pass:
		case TeamStatType.Pass:
			filterValues.push({key: "event.distribution.pass", value: ["pass"]});
			break;
		case PlayerStatType.PassSuccess:
		case TeamStatType.PassSuccess:
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassBackward:
		case TeamStatType.PassBackward:
			filterValues.push({key: "event.distribution.pass.direction", value: ["backward"]});
			break;
		case PlayerStatType.PassBackwardSuccess:
		case TeamStatType.PassBackwardSuccess:
			filterValues.push({key: "event.distribution.pass.direction", value: ["backward"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassForward:
		case TeamStatType.PassForward:
			filterValues.push({key: "event.distribution.pass.direction", value: ["forward"]});
			break;
		case PlayerStatType.PassForwardSuccess:
		case TeamStatType.PassForwardSuccess:
			filterValues.push({key: "event.distribution.pass.direction", value: ["forward"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassInDefensiveThird:
		case TeamStatType.PassInDefensiveThird:
			filterValues.push({key: "event.distribution.pass.third", value: ["defensive"]});
			break;
		case PlayerStatType.PassInDefensiveThirdSuccess:
		case TeamStatType.PassInDefensiveThirdSuccess:
			filterValues.push({key: "event.distribution.pass.third", value: ["defensive"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassInFinalThird:
		case TeamStatType.PassInFinalThird:
			filterValues.push({key: "event.distribution.pass.third", value: ["final"]});
			break;
		case PlayerStatType.PassInFinalThirdSuccess:
		case TeamStatType.PassInFinalThirdSuccess:
			filterValues.push({key: "event.distribution.pass.third", value: ["final"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassInMiddleThird:
		case TeamStatType.PassInMiddleThird:
			filterValues.push({key: "event.distribution.pass.third", value: ["middle"]});
			break;
		case PlayerStatType.PassInMiddleThirdSuccess:
		case TeamStatType.PassInMiddleThirdSuccess:
			filterValues.push({key: "event.distribution.pass.third", value: ["middle"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassLong:
		case TeamStatType.PassLong:
			filterValues.push({key: "event.distribution.pass.length", value: ["long"]});
			break;
		case TeamStatType.LongBallShare:
		case PlayerStatType.PassLongSuccess:
		case TeamStatType.PassLongSuccess:
			filterValues.push({key: "event.distribution.pass.length", value: ["long"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassMedium:
		case TeamStatType.PassMedium:
			filterValues.push({key: "event.distribution.pass.length", value: ["medium"]});
			break;
		case PlayerStatType.PassMediumSuccess:
		case TeamStatType.PassMediumSuccess:
			filterValues.push({key: "event.distribution.pass.length", value: ["medium"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassSideways:
		case TeamStatType.PassSideways:
			filterValues.push({key: "event.distribution.pass.direction", value: ["sideways"]});
			break;
		case PlayerStatType.PassSidewaysSuccess:
		case TeamStatType.PassSidewaysSuccess:
			filterValues.push({key: "event.distribution.pass.direction", value: ["sideways"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.PassShort:
		case TeamStatType.PassShort:
			filterValues.push({key: "event.distribution.pass.length", value: ["short"]});
			break;
		case PlayerStatType.PassShortSuccess:
		case TeamStatType.PassShortSuccess:
			filterValues.push({key: "event.distribution.pass.length", value: ["short"]});
			filterValues.push({key: "event.distribution.pass.success", value: ["true"]});
			break;
		case PlayerStatType.Recovery:
		case TeamStatType.Recovery:
			filterValues.push({key: "event.defensive.recovery", value: ["recovery"]});
			break;
		case PlayerStatType.Shot:
			filterValues.push({key: "event.offensive.shot", value: ["shot"]});
			break;
		case PlayerStatType.ShotBlocked:
		case TeamStatType.ShotBlocked:
			filterValues.push({key: "event.offensive.shot.on_target", value: ["blocked"]});
			break;
		case PlayerStatType.ShotInsidePa:
		case TeamStatType.ShotInsidePa:
			filterValues.push({key: "event.offensive.shot.inside_pa", value: ["true"]});
			break;
		case PlayerStatType.ShotOffTarget:
		case TeamStatType.ShotOffTarget:
			filterValues.push({key: "event.offensive.shot.on_target", value: ["off"]});
			break;
		case PlayerStatType.ShotOnTarget:
		case TeamStatType.ShotOnTarget:
			filterValues.push({key: "event.offensive.shot.on_target", value: ["on"]});
			break;
		case PlayerStatType.ShotOutsidePa:
		case TeamStatType.ShotOutsidePa:
			filterValues.push({key: "event.offensive.shot.inside_pa", value: ["false"]});
			break;
		case PlayerStatType.Tackle:
		case TeamStatType.Tackle:
			filterValues.push({key: "event.defensive.tackle", value: ["tackle"]});
			break;
		case PlayerStatType.TackleSuccess:
		case TeamStatType.TackleSuccess:
			filterValues.push({key: "event.defensive.tackle.success", value: ["true"]});
			break;
		case PlayerStatType.TakeOn:
		case TeamStatType.TakeOn:
			filterValues.push({key: "event.offensive.take_on", value: ["take_on"]});
			break;
		case PlayerStatType.TakeOnSuccess:
		case TeamStatType.TakeOnSuccess:
			filterValues.push({key: "event.offensive.take_on.success", value: ["true"]});
			break;
		case PlayerStatType.ThrowIn:
			filterValues.push({key: "event.distribution.pass.restart", value: ["throw-in"]});
			break;
		case PlayerStatType.CatchInterception:
			filterValues.push({key: "event.goalkeeper.catch_interception", value: ["catch_interception"]});
			break;
		case PlayerStatType.Card:
			filterValues.push({key: "event.defensive.card", value: ["card"]});
			break;
		case PlayerStatType.LoseBallRecovery:
			filterValues.push({key: "event.defensive.recovery", value: ["recovery"]});
			break;
		case PlayerStatType.Save:
			filterValues.push({key: "event.goalkeeper.save", value: ["save"]});
			break;
		case PlayerStatType.PassReceived:
			filterValues.push({key: "event.distribution.pass_received", value: ["pass_received"]});
			break;
		case PlayerStatType.TakeOnAgainst:
			filterValues.push({key: "event.defensive.take_on_against", value: ["take_on_against"]});
			break;
		case PlayerStatType.Punch:
			filterValues.push({key: "event.goalkeeper.punch", value: ["punch"]});
			break;
		case PlayerStatType.NonPenaltyGoal:
			filterValues.push({key: "event.offensive.goal.non_penalty_goal", value: ["true"]});
			break;
		case PlayerStatType.ShotCreatingAction:
		case TeamStatType.ShotCreatingAction:
			filterValues.push({key: "event.distribution.pass.shot_creating_action", value: ["true"]});
			filterValues.push({key: "event.offensive.take_on.shot_creating_action", value: ["true"]});
			filterValues.push({key: "event.offensive.foul_won.shot_creating_action", value: ["true"]});
			break;
		case PlayerStatType.PassIntoPenaltyArea:
		case TeamStatType.PassIntoPenaltyArea:
			filterValues.push({key: "event.distribution.pass.into_penalty_area", value: ["true"]});
			break;
		case TeamStatType.PassIntoFinalThird:
			filterValues.push({key: "event.distribution.pass.into_final_third", value: ["true"]});
			break;
		case PlayerStatType.SwitchOfPlay:
			filterValues.push({key: "event.distribution.pass.switch_of_play", value: ["true"]});
			break;
		case PlayerStatType.ProgressivePass:
		case TeamStatType.ProgressivePass:
			filterValues.push({key: "event.distribution.pass.progressive", value: ["true"]});
			break;
		case PlayerStatType.DeepCompletion:
		case TeamStatType.DeepCompletion:
			filterValues.push({key: "event.distribution.pass.deep_completion", value: ["true"]});
			break;
	}

	return filterValues;
}
